/**
 * "How MCP sign-in works" — MCP section (ADR-0074).
 * Reconciled from the OAuth controllers (protected-resource metadata, register,
 * authorize, token) and the IdP federation flow.
 */
import type { DocPageContent } from '../types';

export const MCP_AUTH_PAGE: DocPageContent = {
  slug: 'mcp/authentication',
  titleKey: 'docs.mcp.auth.title',
  descriptionKey: 'docs.mcp.auth.description',
  blocks: [
    { kind: 'paragraph', textKey: 'docs.mcp.auth.lead' },

    { kind: 'heading', level: 2, id: 'flow', textKey: 'docs.mcp.auth.flow.heading' },
    { kind: 'paragraph', textKey: 'docs.mcp.auth.flow.body' },
    {
      kind: 'steps',
      steps: [
        {
          titleKey: 'docs.mcp.auth.step.discover.title',
          textKey: 'docs.mcp.auth.step.discover.text',
        },
        {
          titleKey: 'docs.mcp.auth.step.register.title',
          textKey: 'docs.mcp.auth.step.register.text',
        },
        {
          titleKey: 'docs.mcp.auth.step.authorize.title',
          textKey: 'docs.mcp.auth.step.authorize.text',
        },
        { titleKey: 'docs.mcp.auth.step.idp.title', textKey: 'docs.mcp.auth.step.idp.text' },
        { titleKey: 'docs.mcp.auth.step.token.title', textKey: 'docs.mcp.auth.step.token.text' },
        {
          titleKey: 'docs.mcp.auth.step.connect.title',
          textKey: 'docs.mcp.auth.step.connect.text',
        },
      ],
    },

    { kind: 'heading', level: 2, id: 'identity', textKey: 'docs.mcp.auth.identity.heading' },
    { kind: 'paragraph', textKey: 'docs.mcp.auth.identity.body' },
    {
      kind: 'callout',
      tone: 'important',
      titleKey: 'docs.mcp.auth.note.title',
      textKey: 'docs.mcp.auth.note.body',
      links: {
        identity: { target: { docSlug: 'identity' }, labelKey: 'docs.mcp.auth.note.link' },
      },
    },

    { kind: 'heading', level: 2, id: 'next', textKey: 'docs.common.nextSteps' },
    {
      kind: 'cardGrid',
      cards: [
        {
          titleKey: 'docs.mcp.auth.next.connect.title',
          textKey: 'docs.mcp.auth.next.connect.text',
          to: { docSlug: 'mcp/connect' },
        },
        {
          titleKey: 'docs.mcp.auth.next.tools.title',
          textKey: 'docs.mcp.auth.next.tools.text',
          to: { docSlug: 'mcp/tools' },
        },
      ],
    },
  ],
};
